import { doGet } from '@/services/api/base'

/**
 * Ping the API
 * @returns Promise<any> The response from the API
 */
export const ping = async (): Promise<any> => {
  return await doGet('/api/ping')
}
